"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _templates = _interopRequireDefault(require("./templates"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getTemplate = function getTemplate(eventType) {
  var _templates$eventType;
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (_templates$eventType = _templates["default"][eventType]) === null || _templates$eventType === void 0 ? void 0 : _templates$eventType.call(_templates["default"], values);
};
var _default = exports["default"] = getTemplate;